export interface TableViewData {
  id: number
  name: string
  number: number
  site: string
  battery: number
  datetime: number
  temperature: number
  a1: string
  a2: string
  b1: string
  b2: string
  c1: string
  c2: string
}

interface Props {
  data: TableViewData[]
}

export function DeviceSummaryStatus({ data }: Props) {
  const headers = ['Name', 'Number', 'Site', 'Battery', 'Date / Time', 'Temp', 'A1', 'A2', 'B1', 'B2', 'C1', 'C2']

  return (
    <table className="table-auto w-full">
      <thead>
        <tr className=" bg-gray-100 border-y-2 border-x-gray-400">
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index} className="border-y-2 border-x-gray-400">
            <td>{item.name}</td>
            <td>{item.number}</td>
            <td>{item.site}</td>
            <td>{item.battery}</td>
            <td>{item.datetime}</td>
            <td>{item.temperature}</td>
            <td>{item.a1}</td>
            <td>{item.a2}</td>
            <td>{item.b1}</td>
            <td>{item.b2}</td>
            <td>{item.c1}</td>
            <td>{item.c2}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
